import { useState } from 'react';

import { Modal } from '@rikstv/play-common/src/components/modal/Modal';
import { PinPanelModal } from '@rikstv/play-common/src/components/pin/PinPanel';
import { TrailerIcon } from '@rikstv/play-common/src/icons';
import { TrailerPlayer } from '@rikstv/play-player/src/components/TrailerPlayer/TrailerPlayer';
import { useTrailerPlayerStore } from '@rikstv/play-player/src/components/TrailerPlayer/useTrailerPlayerStore';
import { TertiaryButton } from '@rikstv/shared-components';

import styles from '../../StackedEpisodeOrMoviePage.module.css';

export const PlayTrailerButton = ({ ageLimit }: { ageLimit?: number }) => {
  const [openTrailerModal, setOpenTrailerModal] = useState(false);
  const [openPinModal, setOpenPinModal] = useState(false);
  const setPlayBackgroundTrailer = useTrailerPlayerStore(s => s.setPlayBackgroundTrailer);
  const trailerSources = useTrailerPlayerStore(s => s.trailerSources);

  if (!trailerSources) {
    return null;
  }

  const onClose = () => {
    setOpenTrailerModal(false);
    setPlayBackgroundTrailer(true);
  };

  return (
    <>
      <TertiaryButton
        className={styles.buttonWithIcon}
        onClick={() => {
          setOpenPinModal(true);
        }}>
        <TrailerIcon />
        <span>Vis Trailer</span>
      </TertiaryButton>

      <Modal center open={openTrailerModal} onClose={onClose} className={styles.playerModal}>
        <TrailerPlayer className={styles.trailerPlayer} trailerSources={trailerSources} onCloseModalPlayer={onClose} />
      </Modal>

      {openPinModal && (
        <PinPanelModal
          isOpen={openPinModal}
          onClose={() => setOpenPinModal(false)}
          context={'parentalControls'}
          ageRestriction={ageLimit}
          onAccessGranted={() => {
            setOpenTrailerModal(true);
            setPlayBackgroundTrailer(false);
          }}
        />
      )}
    </>
  );
};
